import { Grid } from '@material-ui/core';
import { DocumentType } from '@nemuru-eng/js-api-client';

import { useKYCDocumentIdImages } from '@/components/modules/KYC/KYCLoan/BorrowerKYC/components/DocumentIdSection/hooks/useKYCDocumentIdImages';
import { DocumentVisualizer } from '@/components/shared/components/DocumentVisualizer';

interface DocumentIdImagesProps {
  loanId: string;
  borrowerId: string | null;
  documentType: DocumentType;
  onLoaded?: () => void;
  onError?: (revalidate: () => void) => void;
}

export const DocumentIdImages = ({ loanId, borrowerId, documentType, onLoaded, onError }: DocumentIdImagesProps) => {
  if (!borrowerId) {
    return null;
  }

  const { loading, borrowerIdImages } = useKYCDocumentIdImages({ loanId, borrowerId, onLoaded, onError });

  if (documentType === DocumentType.PASSPORT) {
    return (
      <Grid container spacing={4}>
        <Grid item xs={12} lg={6}>
          <DocumentVisualizer
            id={`visualizer-passport-${borrowerId}`}
            documentFile={borrowerIdImages?.passport}
            loading={loading}
            isImage
          />
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container spacing={4}>
      <Grid item xs={12} lg={6}>
        <DocumentVisualizer
          id={`visualizer-document-id-front-${borrowerId}`}
          documentFile={borrowerIdImages?.documentIdFront}
          loading={loading}
          isImage
        />
      </Grid>
      <Grid item xs={12} lg={6}>
        <DocumentVisualizer
          id={`visualizer-document-id-back-${borrowerId}`}
          documentFile={borrowerIdImages?.documentIdBack}
          loading={loading}
          isImage
        />
      </Grid>
      {documentType === DocumentType.NIE_EU && (
        <Grid item xs={12} lg={6}>
          <DocumentVisualizer
            id={`visualizer-nie-eu-${borrowerId}`}
            documentFile={borrowerIdImages?.passport}
            loading={loading}
            isImage
          />
        </Grid>
      )}
    </Grid>
  );
};
